import { render, staticRenderFns } from "./cancel-request.component.vue?vue&type=template&id=63cb74de&scoped=true"
import script from "./cancel-request.component.vue?vue&type=script&lang=ts"
export * from "./cancel-request.component.vue?vue&type=script&lang=ts"
import style0 from "./cancel-request.component.vue?vue&type=style&index=0&id=63cb74de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb74de",
  null
  
)

export default component.exports